import React, { useState } from 'react';
import { PopoverBody } from 'reactstrap';
import { LoginForm, FormHelpText, TooltipBox, Spinner, SpinnerContainer, CreateProfile } from './style';
import { useLabelsContext } from '../../../../contexts/LabelsContext';
import { useConfigContext } from '../../../../contexts/ConfigContext';
import { useLanguageContext } from '../../../../contexts/LanguageContext';

const SignIn = ({ onContinue, isLoading }) => {
  const { labels } = useLabelsContext();
  const { isPilot, DI_ENDPOINT_CA } = useConfigContext();
  const { language } = useLanguageContext();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [email, setEmail] = useState('');
  const toggle = () => setTooltipOpen(!tooltipOpen);

  const continueClick = () => {
    var applicationForm = document.getElementById('loginForm');

    if ((applicationForm && !applicationForm.checkValidity()) || !validateEmail()) {
      applicationForm.reportValidity();
    } else {
      onContinue(email);
    };
  };

  const handleInputChange = (input) => {
    setEmail(input.value);

    var inputEmail = document.getElementById('inputEmail');
    inputEmail.setCustomValidity("");
  }

  const validateEmail = () => {

    var inputEmail = document.getElementById('inputEmail');

    if (/\S+@\S+\.\S+/.test(inputEmail.value)) {
      inputEmail.setCustomValidity("");
      return true;
    }
    else {
      inputEmail.setCustomValidity("The email entered is not formatted correctly");
      return false;
    }

  };

  const createProfileLink = language.locale.split('-')[1].toUpperCase() === 'US' ? 'https://dfs.dell.com/#/signup' : DI_ENDPOINT_CA;

  return (
    <>
      <LoginForm>
        {isLoading ? (
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        ) : (
          <>
            <form id="loginForm">
              <label>{labels.labelEmailAddress}</label>
              <input id="inputEmail" required value={email} onChange={e => handleInputChange(e.target)}>
              </input>
              <button type="button" onClick={() => continueClick()}>{labels.buttonContinue}</button>
            </form>
            <div>
              <FormHelpText href="#" id="forgotEmail">
                <TooltipBox trigger="hover" placement="bottom-start" isOpen={tooltipOpen} target="forgotEmail" toggle={toggle}>
                  <PopoverBody>
                    DPA customers call
                    <br />
                    <strong>1-800-283-2210,</strong>
                    DBC customers
                    <br />
                    call
                    <strong> 1-866-413-3355</strong>
                    for help with
                    <br />
                    your email address.
                  </PopoverBody>
                </TooltipBox>
              </FormHelpText> 
            </div>
          </>
        )}
      </LoginForm>
      {!isPilot && (
        <CreateProfile>
          New Account Holder?
          <a href={createProfileLink}>Create Profile</a>
        </CreateProfile>
      )}
    </>
  );
};

export default SignIn;
